import React, { Suspense } from 'react'
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom";
import './App.scss';
import './styles.css';
import { useSelector } from 'react-redux';

import LoadingFallback from '../screens/loading/LoadingFallback';

const Layout = React.lazy(() => import('./Layout'));

// Auth pages
const Login = React.lazy(() => import('../screens/login'));
const RequestToRegister = React.lazy(() => import('../screens/requestToRegister'));
const Signup = React.lazy(() => import('../screens/signup'));
const AuthLoading = React.lazy(() => import('../screens/loading'));
const LandingPage = React.lazy(() => import('../screens/LandingPage'));
const ForgotPassword = React.lazy(() => import('../screens/forgotPassword'));
const ResetPassword = React.lazy(() => import('../screens/forgotPassword/resetPassword'));
const CertifiedStudents = React.lazy(() => import('../screens/LandingPage/certifiedStudents'));

// Quiz pages
const Quiz = React.lazy(() => import('../screens/quiz'));
const Loading = React.lazy(() => import('../screens/loading/Loading'));
const PageNotFound = React.lazy(() => import('../screens/PageNotFound'));
const MainWrapper = React.lazy(() => import("../components/MainWrapper"));

export default function Routes() {
    const { isAuth } = useSelector(({ auth }) => auth)

    function PrivateRoute ({ component: Component, auth, ...rest }) {
        return (
          <Route
            {...rest}
            render={(props) => auth === true
              ? <Component {...props} />
              : <Redirect to={{pathname: '/login'}} />}
          />
        )
    }

    return (
        <Router basename={"/certificates"}>
            <Suspense fallback={<LoadingFallback />}>
                <MainWrapper>
                    <Switch>
                        {/* <Route exact path="/" component={AuthLoading} /> */}
                        <Route exact path="/" component={LandingPage} />
                        <Route exact path="/certified-students" component={CertifiedStudents} />
                        <Route exact path="/login" component={Login} />
                        <Route exact path="/request-to-register" component={RequestToRegister} />
                        {/* <Route path="/cretificates" component={LandingPage} /> */}
                        <Route exact path="/signup" component={Signup} />
                        <Route exact path="/forgot-password" component={ForgotPassword} />
                        <Route exact path="/password/reset/:token" component={ResetPassword} />
                        <Route exact path="/app/:token" component={Loading} />
                        <PrivateRoute auth={isAuth} path='/student' component={Layout} />
                        <PrivateRoute auth={isAuth} path='/quiz' component={Quiz} />
                        <Route path="*" component={PageNotFound} />
                    </Switch>
                </MainWrapper>
            </Suspense>
        </Router>
        
    )
}